import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import "../components/AppLayout.css";
import "./AuthPage.css";

export default function Signup() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Passwords do not match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/register", { email, name, password });
      setDone(true);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      if (Array.isArray(detail)) toast.error(detail.map((d) => d.msg).join(", "));
      else toast.error(typeof detail === "string" ? detail : "Sign-up failed");
    } finally {
      setLoading(false);
    }
  };

  const Header = ({ crumbTail }) => (
    <>
      <header className="sms-banner">
        <div className="sms-banner-inner">
          <div className="sms-brand">
            <img src="/crest.svg" alt="" className="sms-brand-crest" width="56" height="50" />
            <span className="sms-brand-text">UK Visas &amp; Immigration</span>
          </div>
        </div>
      </header>
      <nav className="sms-breadcrumb" aria-label="breadcrumb">
        <div className="sms-breadcrumb-inner">
          <span className="sms-crumb-lead">You are here</span>
          <span className="sms-crumb"><span className="sms-crumb-sep">&gt;</span><span>Sponsorship management system</span></span>
          <span className="sms-crumb"><span className="sms-crumb-sep">&gt;</span><span>{crumbTail}</span></span>
        </div>
      </nav>
    </>
  );

  if (done) {
    return (
      <div className="sms-shell">
        <Header crumbTail="Request submitted" />
        <div className="sms-auth-wrap">
          <div className="sms-auth-panel" data-testid="pending-approval-screen">
            <h1>Your account is pending approval</h1>
            <p>
              Thanks for signing up, <strong>{name}</strong>. An administrator will
              review your request shortly. You'll be able to sign in as soon as your
              account is approved.
            </p>
            <p className="sms-auth-muted">Registration received for <strong>{email}</strong>.</p>
            <div className="sms-auth-actions">
              <button
                data-testid="back-to-login"
                onClick={() => navigate("/login")}
                className="sms-btn"
              >
                Back to sign in
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="sms-shell">
      <Header crumbTail="Request access" />
      <div className="sms-auth-wrap">
        <div className="sms-auth-panel">
          <h1>Request access</h1>
          <p className="sms-auth-lead">
            Create your account below. An administrator will review your request —
            once approved, you'll be able to sign in and generate Certificates of
            Sponsorship.
          </p>

          <form onSubmit={submit} data-testid="signup-form" className="sms-auth-form">
            <div className="sms-auth-field">
              <label htmlFor="name">Full name</label>
              <input
                id="name" data-testid="signup-name" className="sms-input"
                value={name} onChange={(e) => setName(e.target.value)} required
              />
            </div>
            <div className="sms-auth-field">
              <label htmlFor="email">Email</label>
              <input
                id="email" data-testid="signup-email" type="email" className="sms-input"
                value={email} onChange={(e) => setEmail(e.target.value)} required
              />
            </div>
            <div className="sms-auth-field">
              <label htmlFor="password">Password</label>
              <input
                id="password" data-testid="signup-password" type="password" className="sms-input"
                value={password} onChange={(e) => setPassword(e.target.value)} minLength={6} required
              />
            </div>
            <div className="sms-auth-field">
              <label htmlFor="confirm">Confirm password</label>
              <input
                id="confirm" data-testid="signup-confirm" type="password" className="sms-input"
                value={confirm} onChange={(e) => setConfirm(e.target.value)} minLength={6} required
              />
            </div>

            <div className="sms-auth-actions">
              <button
                type="submit" data-testid="signup-submit" disabled={loading} className="sms-btn"
              >
                {loading ? "Submitting…" : "Request access"}
              </button>
              <Link to="/login" data-testid="link-to-login" className="sms-auth-link">
                I already have an account
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
